import type { DataUpload } from '@/common/data-upload';
import type { Pagination } from '@/common/pagination';
import { axios } from '@/lib/utils/axios';

import { getResponse } from '../common';
import { API_URLS } from '../query.client';

export type DataUploadsListSuccessResponseType = {
	dataUploads: DataUpload[];
	total: number;
	limit: number;
	offset: number;
};

export type DataUploadsListQueryFilterType = {
	search?: string;
	assetId?: string;
	inspectionId?: string;
	damageId?: string;
	fileType?: string;
	uploadType?: string;
	subAssetId?: string;
	/** Only 3D models whose conversion has this status (queued, processing, ready, error) */
	tilesetStatus?: string;
	/** Only deleted files (needs DATA_UPLOADS_DELETE) */
	deleted?: boolean;
};

export type DataUploadsQueryParams = DataUploadsListQueryFilterType &
	Pagination & {
		sort?: string; // e.g. "name:asc"; see DATA_UPLOAD_SORT_FIELDS
	};

export async function getListDataUploads(
	query: DataUploadsQueryParams,
): Promise<DataUploadsListSuccessResponseType | null> {
	const response = await axios.get(`${API_URLS.DATA_UPLOAD.INDEX}`, {
		params: query,
	});
	return getResponse<DataUploadsListSuccessResponseType>(response.data);
}
